import type { PathConfig } from '@react-navigation/native';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/quick-new',
  screens: {
    'quick-new-choose': '/choose',
    'quick-new-confirm': '/confirm',
    'quick-new-thanks': '/thanks',
  },
};
